import * as types from '../../mutation-types'
import * as api from '../../api'
import router from '../../../router'

const state = {
  site: [],
  sites: [],
  sites_received_timestamp: new Date(0)
}

const getters = {
  singleSite: state => state.site,
  allSites: state => state.sites
}

const actions = {
  getSite ({ commit }, siteId) {
    api.instance.get('sites/' + siteId)
      .then(function (response) {
        const site = response.data.site
        commit(types.RECEIVE_SITE, site)
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  getSites ({ commit, dispatch }) {
    const diff = Math.abs(new Date(state.sites_received_timestamp) - new Date())
    const diffMinutes = Math.floor((diff / 1000) / 60)
    if (diffMinutes >= 1) {
      api.instance.get('sites')
        .then(function (response) {
          const sites = response.data.sites
          commit(types.RECEIVE_SITES, sites)
          dispatch('determineSiteOfIp', sites)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  addEditSite ({ commit }, site) {
    if (site.ip === null) {
      site.ip = ''
    }

    if (site.alt_name === null) {
      site.alt_name = ''
    }

    if (site.site_name !== '' && site.ip !== '') {
      if (site.site_id === 0) {
        api.instance.post('sites', site)
          .then(function (response) {
            if (response.data.success === 'true') {
              site = response.data.site[0]
              commit(types.ADD_SITE, site)
              router.push({ name: 'AdminSiteIndex' })
            } else {
              alert(response.data.message)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        api.instance.put('sites/' + site.site_id, site)
          .then(function (response) {
            if (response.data.success === 'true') {
              site = response.data.site[0]
              commit(types.EDIT_SITE, site)
              router.push({ name: 'AdminSiteIndex' })
            } else {
              alert(response.data.message)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    } else {
      alert('Site and domain name are required')
    }
  },
  deleteSite ({ commit }, site) {
    api.instance.delete('sites/' + site.site_id)
      .then(function (response) {
        commit(types.DELETE_SITE, site)
      })
  },
  uploadSiteLogo ({ commit }, data) {
    let formData = new FormData()
    formData.append('logo', data.file)

    api.instance.post('sites/logo/' + data.site_id, formData, { 'content-type': 'multipart/form-data' })
      .then(function (response) {
        if (response.data.success === 'true') {
          alert('File successfully imported!')
        } else {
          alert(response.data.message)
        }
      })
  }
}

const mutations = {
  [types.RECEIVE_SITE] (state, site) {
    state.site = site
  },
  [types.RECEIVE_SITES] (state, sites) {
    state.sites = sites
    state.sites_received_timestamp = Date.now()
  },
  [types.ADD_SITE] (state, site) {
    state.sites.push(site)
  },
  [types.EDIT_SITE] (state, site) {
    let siteToEdit = state.sites.find(
      function (ele) {
        if (ele.site_id === site.site_id) {
          return true
        }
      }
    )
    let index = state.sites.indexOf(siteToEdit)
    state.sites[index] = site
  },
  [types.DELETE_SITE] (state, site) {
    let siteToDelete = state.sites.find(
      function (ele) {
        if (ele.site_id === site.site_id) {
          return true
        }
      }
    )
    let index = state.sites.indexOf(siteToDelete)
    state.sites.splice(index, 1)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
